<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import ConnectionPanel from 'dashboard/components/uazapi/ConnectionPanel.vue';

const { t } = useI18n();
const router = useRouter();
const store = useStore();

const name = ref('');
const touched = ref(false);
const inbox = ref(null);
const qrcode = ref('');

const isCreating = computed(
  () => store.getters['inboxes/getUIFlags'].isCreating
);
const nameError = computed(() => touched.value && !name.value.trim());

const create = async () => {
  touched.value = true;
  if (!name.value.trim()) return;
  try {
    const data = await store.dispatch(
      'inboxes/createUazapiChannel',
      name.value.trim()
    );
    inbox.value = data;
    qrcode.value = data.uazapi?.qrcode || '';
  } catch (error) {
    useAlert(t('INBOX_MGMT.UAZAPI.ADD.ERROR', { message: error.message }));
  }
};

const goToAgents = () => {
  router.replace({
    name: 'settings_inboxes_add_agents',
    params: { page: 'new', inbox_id: inbox.value.id },
  });
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="t('INBOX_MGMT.UAZAPI.ADD.TITLE')"
      :header-content="t('INBOX_MGMT.UAZAPI.ADD.DESC')"
    />
    <form
      v-if="!inbox"
      class="flex flex-wrap flex-col mx-0"
      @submit.prevent="create"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: nameError }">
          {{ t('INBOX_MGMT.UAZAPI.ADD.NAME_LABEL') }}
          <input
            v-model="name"
            type="text"
            :placeholder="t('INBOX_MGMT.UAZAPI.ADD.NAME_PLACEHOLDER')"
            @blur="touched = true"
          />
          <span v-if="nameError" class="message">{{
            t('INBOX_MGMT.UAZAPI.ADD.NAME_ERROR')
          }}</span>
        </label>
      </div>
      <div class="w-full mt-4">
        <NextButton
          :is-loading="isCreating"
          type="submit"
          solid
          blue
          :label="t('INBOX_MGMT.UAZAPI.ADD.SUBMIT')"
        />
      </div>
    </form>
    <ConnectionPanel
      v-else
      :inbox-id="inbox.id"
      :initial-qrcode="qrcode"
      show-continue
      @connected="goToAgents"
      @continue="goToAgents"
    />
  </div>
</template>
